import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { pvqFinancialRepossessionItemValidator } from './validators/item';
import { FinancialRepossessionModel } from './types';

const financialRepossessionValidator: ValidateJSModel<FinancialRepossessionModel> = {
  HasRepossession: {
    hasValue: { validator: hasYesOrNo },
  },

  List: (value, attributes) => {
    if (attributes?.HasRepossession?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: pvqFinancialRepossessionItemValidator },
      };
    }

    return {};
  },
};

export default financialRepossessionValidator;
